import React from "react";
import { UserCircle } from "lucide-react";
import PageHeader from "components/ui/PageHeader";

const ProfileHeader: React.FC = () => (
    <PageHeader
        icon={<UserCircle className="w-5 h-5" />}
        iconBg="bg-emerald-50 dark:bg-emerald-900/20"
        iconColor="text-emerald-600 dark:text-emerald-400"
        accentColor="bg-gradient-to-r from-emerald-400 to-teal-500"
        title="Your Profile"
        subtitle="Manage account settings and email footer"
    />
);

export default ProfileHeader;
